import React from 'react';
import PropTypes from 'prop-types';
import globe from '../../images/pacer-bottom-globe.png';
import moment from 'moment';
import Icon from '../Common/Icon';

const LoginFooter = ({ showSignUpButton }) => {
    return (
        <footer>
            <div className="feet">
                <div className="left">
                    <div className="mid">
                        {showSignUpButton &&
                            <div>Need a user account? <a href="sign-up"><span className="signup-button">Sign Up</span></a></div>                        
                        }
                        <a href="https://www.getpacer.com/freeTrial"><div>Start your company with Pacer <Icon name="arrow-right"/></div></a>
                        <div><a className="me-2" href="https://ehsolution.zendesk.com/hc/en-us">Support FAQs</a> | <a className="ms-2 me-2" href="https://www.getpacer.com/contact">Contact Us</a> | <a className="ms-2" href="https://www.getpacer.com/privacy">Privacy</a></div>
                        <div>© {moment().format('YYYY')} Pacer. All Rights Reserved.</div>                        
                    </div>
                </div>
                <div className="right">
                    <img src={globe} alt="EH Solution" height="275" />
                </div>                    
            </div>
            
        </footer>
    );
};

LoginFooter.propTypes = {
    showSignUpButton: PropTypes.bool.isRequired
};

export default LoginFooter;
